import graphql from "babel-plugin-relay/macro";

export default graphql`
  query initialValuesQueryQuery($name: String, $first: Int,$appName:String) {
    authorizedOrgs(name: $name, first: $first,appName:$appName) {
      id
      name
      suborgs {
        id
        name
        region
        propertyLogoUrl
        propertyManagerLogoUrl
        linkColor
        fontFamily
        textColor
        buttonBorderColor
        buttonFontColor
        buttonBackgroundColor
      }
    }
  }
`;
